import * as tslib_1 from "tslib";
import { Component, Prop, Provide } from "vue-property-decorator";
import { listApi } from "@cloudpivot/api";
import ControlAdapter from "./pc/control-adapter.vue";
import FormCol from "./pc/form-col.vue";
import FormRow from "./pc/form-row.vue";
import FormGroup from "./layout/form-group.vue";
import FormTabs from "./layout/pc-form-tabs.vue";
import zhToEn from "@cloudpivot/list/src/components/pc/locales/zhToEn";
// import FormTabsPane from "./layout/pc-form-tabs-pane.vue";
import { FormRenderer } from "./form-renderer";
import { Tabs } from "@h3/antd-vue";
let PcFormRenderer = class PcFormRenderer extends FormRenderer {
    getSourceType() {
        return this.sourceType;
    }
    getController() {
        return this.controller;
    }
    findController(key, rowIndex) {
        if (!this.controller) {
            return;
        }
        // @ts-ignore
        return this.controller.findChild(key, rowIndex);
    }
    getFormControls(keys) {
        return super.findFormControls(keys);
    }
    emitSheetColumnResize(data) {
        this.$emit("sheetColumnResize", data);
    }
    valChange(keys, fun) {
        if (this && this.controller) {
            const _ctrl = this.controller.findChild(keys);
            // if (!_ctrl) return;
            _ctrl.valueChange.subscribe(change => {
                fun(change);
            });
        }
    }
    getDataItem(keys, parentKey) {
        if (parentKey) {
            const sheet = this.dataItems.find(res => {
                return res.code === parentKey;
            });
            if (sheet && sheet.subSchema) {
                return sheet.subSchema.properties.find(res => res.code === keys);
            }
        }
        else {
            return this.dataItems.find(res => res.code === keys);
        }
    }
    getFormPermission() {
        return this.formPermission;
    }
    getRelativeDataList(isList) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.relevanceDataList || !this.relevanceDataList.length) {
                let { schemaCode } = this.$route.params;
                if (!schemaCode) {
                    schemaCode = this.$route.params.bizSchemaCode;
                }
                if (!schemaCode) {
                    schemaCode = this.$route.query.schemaCode;
                }
                if (!schemaCode) {
                    schemaCode = this.schemaCode;
                }
                if (isList && this.schemaCode) {
                    schemaCode = this.schemaCode;
                }
                if (!schemaCode) {
                    return;
                }
                const res = yield listApi.getDataItemList({
                    schemaCode
                });
                const { errcode, errmsg, data } = res;
                if (errcode === 0) {
                    return data;
                }
                else {
                    this.$message.error(errmsg);
                }
            }
            return this.relevanceDataList;
        });
    }
    render(h) {
        // 判断当前是否存在英文，如果英文是中文，做一次映射
        if (this.controls.length) {
            const specialKeys = ["name", "creater", "createdTime", "createdDeptId", "sequenceNo", "owner", "ownerDeptId", "modifier", "modifiedTime", "workflowInstanceId", "sequenceStatus", "ownerDeptQueryCode"];
            this.controls.forEach(el => {
                if (el.children) {
                    el.children.forEach(item => {
                        item.children && item.children.forEach(ele => {
                            if (ele.options && specialKeys.indexOf(ele.key) > -1) {
                                if (typeof ele.options.name_i18n === "object" && ele.options.name_i18n !== null) {
                                    ele.options.name_i18n.en = zhToEn[ele.options.name] || ele.options.name;
                                }
                                else {
                                    ele.options.name_i18n = {
                                        en: zhToEn[ele.options.name] || ele.options.name
                                    };
                                }
                                console.log('ele.options.name_i18n===>', ele.options.name_i18n.en);
                            }
                        });
                    });
                }
            });
        }
        return super.render(h, false);
    }
};
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "relevanceDataList", void 0);
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "sourceType", void 0);
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "schemaCode", void 0);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getSourceType", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getController", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "findController", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getFormControls", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "emitSheetColumnResize", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "valChange", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getDataItem", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getFormPermission", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getRelativeDataList", null);
PcFormRenderer = tslib_1.__decorate([
    Component({
        name: "pc-form-renderer",
        components: {
            ControlAdapter,
            FormCol,
            FormRow,
            FormGroup,
            FormTabs,
            // FormTabsPane,
            ATabPane: Tabs.TabPane
        }
    })
], PcFormRenderer);
export default PcFormRenderer;
